import Vue from "vue"
import VueRouter from "vue-router"
import LoadingState from "../consts/LoadingState"
import Permissions from "../consts/Permissions"
import { accessToRoute } from "../plugins/authorized"
import store from "../store"
import AddUserView from "../views/AddUserView.vue"
import AuditDashboard from "../views/audit/AuditDashboard.vue"
import AuditInput from "../views/audit/AuditInput.vue"
import ClientAuditOverview from "../views/audit/ClientAuditOverview.vue"
import DetailedView from "../views/audit/DetailedView.vue"
import EditTemplate from "../views/audit/EditTemplate.vue"
import NewTemplate from "../views/audit/NewTemplate.vue"
import RequestAudit from "../views/audit/RequestAudit.vue"
import SuccessfulSubmissionView from "../views/audit/SuccessfulSubmissionView.vue"
import SupplierAuditOverview from "../views/audit/SupplierAuditOverview.vue"
import TemplateOverview from "../views/audit/TemplateOverview.vue"
import TemplatePreview from "../views/audit/TemplatePreview"
import AuditView from "../views/AuditView.vue"
import ApiKeys from "../views/connections/ApiKeys.vue"
import ApiKeysList from "../views/connections/ApiKeysList.vue"
import ConnectionsOverview from "../views/connections/ConnectionsOverview.vue"
import CSRConnectionsList from "../views/connections/CSRConnectionsList.vue"
import CSRConnectionsMap from "../views/connections/CSRConnectionsMap.vue"
import ESGConnectionsPage from "../views/ESGConnectionsPage.vue"
import EmissionsConnectionsList from "../views/connections/EmissionsConnectionsList"
import SingleClientView from "../views/connections/SingleClientView"
import ConnectionsView from "../views/ConnectionsView"
import SupplierPerformanceView from "../views/SupplierPerformanceView.vue"
import SupplierPerformanceTable from "../views/SupplierPerformanceTable.vue"
import SupplierPerformanceConnectionMap from "../views/SupplierPerformanceConnectionMap.vue"
import CsrInput from "../views/CsrInput.vue"
import CsrView from "../views/CsrView.vue"
import CsrReView from "../views/CsrResubmit.vue"
import EditUserView from "../views/EditUserView.vue"
import EmissionsResult from "../views/EmissionsResult.vue"
import EmissionsView from "../views/EmissionsView.vue"
import EmptyRouterView from "../views/EmptyRouterView.vue"
import NotFound from "../views/error/NotFound.vue"
import Unauthorized from "../views/error/Unauthorized.vue"
import Verify from "../views/logins/EmailVerification.vue"
import EPR from "../views/logins/EPR.vue"
import Forgot from "../views/logins/Forgot.vue"
import Invite from "../views/logins/Invite.vue"
import JoinView from "../views/logins/JoinView.vue"
import Login from "../views/logins/Login.vue"
import Register from "../views/logins/Register.vue"
import Reset from "../views/logins/Reset.vue"
import VerifyEmailView from "../views/logins/VerifyEmailView.vue"
import Portal from "../views/Portal.vue"
import GuestPortal from "../views/GuestPortal.vue"
import GuestAudit from "../views/GuestAudit.vue"
import GuestAuditSuccess from "../views/GuestAuditSuccess.vue"
import Knowledge from "../views/Knowledge.vue"
import RequestCSR from "../views/RequestCSR.vue"
import TeamSettings from "../views/team/TeamSettings.vue"
import AddTransaction from "../views/trace/AddTransaction"
import ChainHistoryView from "../views/trace/ChainHistoryView"
import CloneTransactionView from "../views/trace/CloneTransactionView"
import CommentsListView from "../views/trace/CommentsListView.vue"
import CommentView from "../views/trace/CommentView"
import DashboardView from "../views/trace/DashboardView"
import DashboardPDF from "../views/DashboardPDF.vue"
import DraftDetailsView from "../views/trace/DraftDetails"
import ForwardTransaction from "../views/trace/ForwardTransaction"
import RecipientView from "../views/trace/RecipientView"
import ReplaceTransaction from "../views/trace/ReplaceTransaction"
import SearchTransactionView from "../views/trace/SearchTransactionView"
import SendTransactionView from "../views/trace/SendTransactionView"
import TransactionCommentsView from "../views/trace/TransactionCommentsView"
import TransactionDetailsView from "../views/trace/TransactionDetailsView"
import TraceView from "../views/TraceView.vue"
import UsersListView from "../views/UsersListView.vue"
import UsersView from "../views/UsersView.vue"
import Riskmatrix from "../views/Riskmatrix.vue"
import Dashboard from "../views/Dashboard.vue"
import ESGscore from "../views/ESGscore.vue"
import Vsme from "../views/Vsme.vue"
import VsmeBusiness from "../views/VsmeBusiness.vue"
import VsmeWater from "../views/VsmeWater.vue"
import VsmeHealth from "../views/VsmeHealth.vue"
import VsmeDiversity from "../views/VsmeDiversity.vue"
import ValueChain from "../views/ValueChain.vue"
import ValueChainResult from "../views/ValueChainResult.vue"
import KnowledgePage from "../views/KnowledgePage.vue"
import RiskPage from "../views/RiskPage.vue"
import RiskDefinition from "../views/RiskDefinition.vue"
import AddRiskViewpoints from "../views/AddRiskViewpoints.vue"
import ESGscorePage from "../views/ESGscorePage.vue"
import ESGconnectionsScore from "../views/ESGconnectionsScore.vue"
import AddActionPlan from "../views/AddActionPlan.vue"
import UpdateRiskViewpoint from "../views/UpdateRiskViewpoint.vue"
import EditRiskViewpoint from "../views/EditRiskViewpoint.vue"
import UpdateActionPlan from "../views/UpdateActionPlan.vue"
import SustainabilityView from "../views/SustainabilityView.vue"
import NisView from "../views/NisView.vue"
import NisSurvey from "../views/NisSurvey.vue"
import NisScore from "../views/NisScore.vue"
import NisYourScore from "../views/NisYourScore.vue"
import NisConnectionsScore from "../views/NisConnectionsScore.vue"
import NisConnectionsTable from "../views/NisConnectionsTable.vue"
import NisConnectionsMap from "../views/NisConnectionsMap.vue"
import RequestNis from "../views/RequestNis.vue"
import RiskView from "../views/RiskView.vue"
import RiskDashboard from "../views/RiskDashboard.vue"
import RiskDashboardPDF from "../views/RiskDashboardPDF.vue"
import ISOprocess from "../views/Isoprocess.vue"
import ProcessView from "../views/ProcessView.vue"
import IncidentLogin from "../views/incident/IncidentLogin.vue"
import IncidentForm from "../views/incident/IncidentForm.vue"
import IncidentOverview from "../views/incident/IncidentOverview.vue"

import AuditOnsiteView from "../views/AuditOnsiteView.vue"
import OnsiteDetailedView from "../views/auditonsite/OnsiteDetailedView.vue"
import SupplierOnsiteDetail from "../views/auditonsite/SupplierOnsiteDetail.vue"
import OnsiteTemplateOverview from "../views/auditonsite/OnsiteTemplateOverview.vue"
import OnsiteInitiaatorDashboard from "../views/auditonsite/OnsiteInitiaatorDashboard.vue"
import ClientAuditOnsiteOverview from "../views/auditonsite/ClientAuditOnsiteOverview.vue"
import AuditOnsiteDashboard from "../views/auditonsite/AuditOnsiteDashboard.vue"
import RequestAuditOnsite from "../views/auditonsite/RequestAuditOnsite.vue"
import OnsiteTemplatePreview from "../views/auditonsite/OnsiteTemplatePreview"
import AuditorAuditOnsiteOverview from "../views/auditonsite/AuditorAuditOnsiteOverview.vue"
import SupplierAuditOnsiteOverview from "../views/auditonsite/SupplierAuditOnsiteOverview.vue"
import EditOnsiteTemplate from "../views/auditonsite/EditOnsiteTemplate.vue"
import NewOnsiteTemplate from "../views/auditonsite/NewOnsiteTemplate.vue"
import AuditOnsiteInput from "../views/auditonsite/AuditOnsiteInput.vue"
import SuccessfulOnsiteSubmissionView from "../views/auditonsite/SuccessfulOnsiteSubmissionView.vue"
import ScheduleView from "../views/auditonsite/ScheduleView.vue"
import OnsiteAuditImprovements from "../views/auditonsite/OnsiteAuditImprovements.vue"

import AuditFlowDownView from "../views/AuditFlowDownView.vue"
import FlowDownDetailedView from "../views/auditflowdown/FlowDownDetailedView.vue"
import FlowDownTemplateOverview from "../views/auditflowdown/FlowDownTemplateOverview.vue"
import ClientAuditFlowDownOverview from "../views/auditflowdown/ClientAuditFlowDownOverview.vue"
import AuditFlowDownDashboard from "../views/auditflowdown/AuditFlowDownDashboard.vue"
import RequestAuditFlowDown from "../views/auditflowdown/RequestAuditFlowDown.vue"
import RequestAuditFlowDown1 from "../views/auditflowdown/RequestAuditFlowDown1.vue"
import FlowDownTemplatePreview from "../views/auditflowdown/FlowDownTemplatePreview"
import SupplierAuditFlowDownOverview from "../views/auditflowdown/SupplierAuditFlowDownOverview.vue"
import EditFlowDownTemplate from "../views/auditflowdown/EditFlowDownTemplate.vue"
import NewFlowDownTemplate from "../views/auditflowdown/NewFlowDownTemplate.vue"
import AuditFlowDownInput from "../views/auditflowdown/AuditFlowDownInput.vue"
import SuccessfulFlowDownSubmissionView from "../views/auditflowdown/SuccessfulFlowDownSubmissionView.vue"
import AccountPlan from "../views/PlansView.vue"
import UpgradePlan from "../views/accout/UpgradePlansV2.vue"
import PaymentSuccess from "../views/accout/PaymentSuccess.vue"
import PaymentFail from "../views/accout/PaymentFail.vue"

Vue.use(VueRouter)

const routes = [
	{
		path: "*",
		component: NotFound,
		meta: {
			requiresAuth: true,
			product: Permissions.Product.Platform
		}
	},
	{
		path: "/unauthorized",
		component: Unauthorized,
		meta: {
			requiresAuth: false,
			product: Permissions.Product.Platform
		}
	},
	{
		path: "/",
		component: Portal,
		name: "Portal",
		meta: {
			requiresAuth: true,
			product: Permissions.Product.Platform,
			resource: Permissions.Resource.Portal
		}
	},
	{
		path: "/knowledge",
		component: Knowledge,
		name: "Knowledge",
	},
	{
		path: "/guestPortal",
		component: GuestPortal,
		meta: {
			requiresAuth: true,
			guestsOnly: true
		},
	},
	{
		path: "/guestaudit/:id",
		name: "GuestAudit",
		component: GuestAudit,
		meta: {
			guestsOnly: true
		},
	},
	{
		path: "/guestauditsuccess",
		name: "GuestAuditSuccess",
		component: GuestAuditSuccess,
		meta: {
			guestsOnly: true
		},
	},
	{
		path: "/chain",
		beforeEnter() {
			window.location = "https://nodes.orixe.tech/"
		}
	},
	{
		path: "/csr",
		component: SustainabilityView,
		name: "Sustainability",
		meta: {
			requiresAuth: true,
			product: Permissions.Product.Platform,
			resource: Permissions.Resource.CSR
		},
		children: [
			{
				path: "/DashboardPDF",
				name: "DashboardPDF",
				component: DashboardPDF,

			},

			{
				path: "request",
				name: "Request Sustainability Self-Assessment",
				component: RequestCSR,
				meta: { name: "Sustainability Request" }
			},
			{
				path: "submit",
				alias: "",
				name: "Submit Sustainability Self-Assessment",
				component: CsrInput,
				meta: { name: "Sustainability Self-Assessment" }
			},
			{
				path:
					"submissions" /* This will be a list of submissions in the future */,
				name: "Submissions",
				beforeEnter() {
					window.location =
						"/" /* Should not redirect back to portal in the future! */
				}
			},
			{
				path: "submissions/:id",
				name: "View Sustainability Self-Assessment",
				component: CsrView,
				meta: { name: "Sustainability View" }
			},
			{
				path: "resubmissions",
				name: "View Sustainability Self-Assessment",
				component: CsrReView,
				meta: { name: "Sustainability View" }
			},
			{
				path: "dashboard",
				name: "dashboard",
				component: Dashboard,
				meta: { name: "Sustainability View" }
			},
			{
				path: "esgscore",
				name: "esgscore",
				component: ESGscorePage,
				meta: { name: "Sustainability View" },
				children: [
					{
						path: "vsmebusiness",
						name: "vsmebusiness",
						component: VsmeBusiness,
					},
					{
						path: "vsmewater",
						name: "vsmewater",
						component: VsmeWater,
					},
					{
						path: "vsmehealth",
						name: "vsmehealth",
						component: VsmeHealth,
					},
					{
						path: "vsmediversity",
						name: "vsmediversity",
						component: VsmeDiversity,
					},
					{
						path: "vsme",
						name: "vsme",
						component: Vsme,
					},
					{
						path: "valuechain",
						name: "valuechain",
						component: ValueChain,
					},
					{
						path: "valuechain/:id",
						name: "valuechainResult",
						component: ValueChainResult,
					},
					{
						path: "esgpage",
						name: "esgpage",
						component: ESGscore,
					},
					{
						path: "suppliers",
						name: "Connections Sustainability Overview",
						component: ESGConnectionsPage,
						meta: { name: "Connections Sustainability Overview" },
						children: [
							{
								path: "CSRConnectionsList",
								name: "CSRConnectionsList",
								component: CSRConnectionsList,
							},
							{
								path: "CSRConnectionsMap",
								name: "Connections Sustainability CSRConnectionsMap",
								component: CSRConnectionsMap,
								meta: { name: "Connections Sustainability CSRConnectionsMap" }
							},
						]
					},
				]
			},
			{
				path: "riskmatrix",
				name: "riskmatrix",
				component: Riskmatrix,
				meta: { name: "Sustainability View" },
				children: [
					{
						path: "riskpage",
						name: "riskpage",
						component: RiskPage,
					},
					{
						path: "riskdefinition",
						name: "riskdefinition",
						component: RiskDefinition,
					},
					{
						path: "add",
						name: "Add user",
						component: AddRiskViewpoints,
					},
					{
						path: "addaction",
						name: "Add user",
						component: AddActionPlan,
					},
					{
						path: "update",
						name: "Add user",
						component: UpdateRiskViewpoint,
					},
					{
						path: "edit",
						name: "Add user",
						component: EditRiskViewpoint,
					},
					{
						path: "updateaction",
						name: "Add user",
						component: UpdateActionPlan,
					}
				]
			},
			{
				path: "knowledgepage",
				name: "knowledgepage",
				component: KnowledgePage,
				meta: { name: "Sustainability View" }
			},
			{
				path: "esgconnections",
				name: "esgconnections",
				component: ESGconnectionsScore,
			},

		]
	},
	{
		path: "/audit",
		component: AuditView,
		meta: {
			requiresAuth: true,
			product: Permissions.Product.Audit,
			name: "Audit"
		},

		children: [

			{
				path: "",
				name: "Audit Dashboard",
				alias: "dashboard",
				component: AuditDashboard,
				meta: { name: "Dashboard" }
			},
			{
				path: "audits",
				component: EmptyRouterView,
				meta: { name: "Audits" },
				children: [
					{
						path: ":id",
						name: "Audit Details",
						component: DetailedView,
						meta: { name: "Audit Details" }
					}
				]
			},
			{
				path: "auditor",
				component: EmptyRouterView,
				children: [
					{
						path: "",
						name: "Audit Overview",
						component: ClientAuditOverview,
						meta: {
							name: "Auditor View",
							resource: Permissions.Resource.AuditRequests,
							operation: "C"
						},
					},
					{
						path: "new",
						name: "New Request",
						component: RequestAudit,
						meta: {
							name: "New Request",
							resource: Permissions.Resource.AuditRequests,
							operation: "C"
						}
					}
				]
			},
			{
				path: "/apikeylist",
				component: ApiKeys,
				meta: {
					requiresAuth: true
				},
				children: [
					{
						path: "",
						name: "API Keys List",
						component: ApiKeysList,
						meta: { name: "API Keys List" }
					}
				]
			},
			{
				path: "submitter",
				component: EmptyRouterView,
				children: [
					{
						path: "",
						name: "Submitter View",
						component: SupplierAuditOverview,
						meta: {
							name: "Submitter View",
							resource: Permissions.Resource.Audits
						}
					},
					{
						path: ":id",
						component: EmptyRouterView,
						children: [
							{
								path: "",
								name: "Fill out",
								component: AuditInput,
								meta: {
									name: "Fill out",
									resource: Permissions.Resource.Audits,
									operation: "C"
								}
							},
							{
								path: "success",
								name: "Success",
								component: SuccessfulSubmissionView,
								meta: {
									name: "Success",
									resource: Permissions.Resource.Audits
								}
							}
						]
					}
				]
			},
			{
				path: "templates",
				component: EmptyRouterView,
				meta: {
					name: "Audit Templates",
					resource: Permissions.Resource.AuditTemplates
				},
				children: [
					{
						path: "",
						name: "Template Overview",
						component: TemplateOverview,
						meta: { name: "Overview" }
					},
					{
						path: "new",
						name: "New Audit Template",
						component: NewTemplate,
						meta: { name: "New" }
					},
					{
						path: ":id",
						component: EmptyRouterView,
						children: [
							{
								path: "",
								name: "Edit Audit Template",
								component: EditTemplate,
								meta: { name: "Edit" }
							},
							{
								path: "preview",
								name: "Preview Audit Template",
								component: TemplatePreview,
								meta: { name: "Preview" }
							}
						]
					}
				]
			}
		]

	},
	{
		path: "/auditonsite",
		component: AuditOnsiteView,
		meta: {
			requiresAuth: true,
			product: Permissions.Product.Audit,
			name: "AuditOnsite"
		},

		children: [

			{
				path: "",
				name: "Audit Onsite Dashboard",
				alias: "dashboard",
				component: AuditOnsiteDashboard,
				meta: { name: "OnsiteDashboard" }
			},
			{
				path: "onsiteaudits",
				component: EmptyRouterView,
				meta: { name: "Audits" },
				children: [
					{
						path: ":id",
						name: "Audit Onsite Details",
						component: OnsiteDetailedView,
						meta: { name: "Audit Onsite Details" }
					}
				]
			},
			{
				path: "onsitesupplieraudits",
				component: EmptyRouterView,
				meta: { name: "Audits" },
				children: [
					{
						path: ":id",
						name: "Audit Onsite Details",
						component: SupplierOnsiteDetail,
						meta: { name: "Audit Onsite Details" }
					}
				]
			},
			{
				path: "onsitedashboard",
				name: "Onsite Initiator Dashboard",
				component: OnsiteInitiaatorDashboard,
				meta: { 
					name: "InitiatorDashboard",
					resource: Permissions.Resource.OnsiteAuditRequest,
					operation: "C"
				}
			},
			{
				path: "onsitesender",
				component: EmptyRouterView,
				children: [
					{
						path: "",
						name: "Audit Onsite Overview",
						component: ClientAuditOnsiteOverview,
						meta: {
							name: "Onsite Sender View",
							resource: Permissions.Resource.OnsiteAuditRequest,
							operation: "C"
						},
					},
					{
						path: "newonsite",
						name: "New Onsite Request",
						component: RequestAuditOnsite,
						meta: {
							name: "New Onsite Request",
							resource: Permissions.Resource.OnsiteAuditRequest,
							operation: "C"
						}
					},
				]
			},
			{
				path: "/apikeylist",
				component: ApiKeys,
				meta: {
					requiresAuth: true
				},
				children: [
					{
						path: "",
						name: "API Keys List",
						component: ApiKeysList,
						meta: { name: "API Keys List" }
					}
				]
			},
			{
				path: "onsiteauditor",
				component: EmptyRouterView,
				children: [
					{
						path: "",
						name: "Onsite Submitter View",
						component: AuditorAuditOnsiteOverview,
						meta: {
							name: "Onsite Auditor View",
							resource: Permissions.Resource.OnsiteAudits,
							operation: "C"
						}
					},
					{
						path: ":id",
						component: EmptyRouterView,
						children: [
							{
								path: "",
								name: "Fill out Onsite",
								component: AuditOnsiteInput,
								meta: {
									name: "Fill out Onsite",
									resource: Permissions.Resource.OnsiteAudits,
									operation: "C"
								}
							},
							{
								path: "success",
								name: "Success",
								component: SuccessfulOnsiteSubmissionView,
								meta: {
									name: "Success",
									resource: Permissions.Resource.OnsiteAudits
								}
							}
						]
					},
					{
						path: "schedule/:id",
						name: "Schedule",
						component: ScheduleView,
						meta: {
							name: "Schedule",
							resource: Permissions.Resource.OnsiteAudits
						}
					}
				]
			},
			{
				path: "onsitesupplier",
				component: EmptyRouterView,
				children: [
					{
						path: "",
						name: "Onsite Supplier View",
						component: SupplierAuditOnsiteOverview,
						meta: {
							name: "Onsite Supplier View",
							resource: Permissions.Resource.Audits,
							operation: "R"
						}
					},
					{
						path: ":id",
						component: EmptyRouterView,
						children: [
							{
								path: "",
								name: "Fill out Onsite",
								component: AuditOnsiteInput,
								meta: {
									name: "Fill out Onsite",
									resource: Permissions.Resource.Audits,
									operation: "C"
								}
							},
							{
								path: "success",
								name: "Success",
								component: SuccessfulOnsiteSubmissionView,
								meta: {
									name: "Success",
									resource: Permissions.Resource.Audits
								}
							},
							{
								path: "improvements",
								name: "Improvements",
								component: OnsiteAuditImprovements,
								meta: {
									name: "Improvements",
									resource: Permissions.Resource.Audits
								}
							}
						]
					}
				]
			},
			{
				path: "onsitetemplates",
				component: EmptyRouterView,
				meta: {
					name: "Audit Onsite Templates",
					resource: Permissions.Resource.OnsiteAuditRequest,
					operation: "C"
				},
				children: [
					{
						path: "",
						name: "Onsite Template Overview",
						component: OnsiteTemplateOverview,
						meta: { name: "OnsiteOverview" }
					},
					{
						path: "newonsite",
						name: "New Onsite Audit Template",
						component: NewOnsiteTemplate,
						meta: { name: "NewOnsite" }
					},
					{
						path: ":id",
						component: EmptyRouterView,
						children: [
							{
								path: "",
								name: "Edit Onsite Audit Template",
								component: EditOnsiteTemplate,
								meta: { name: "EditOnsite" }
							},
							{
								path: "onsitepreview",
								name: "Preview Audit Template",
								component: OnsiteTemplatePreview,
								meta: { name: "FlowDownPreview" }
							}
						]
					}
				]
			}
		]

	},
	{
		path: "/auditflowdown",
		component: AuditFlowDownView,
		meta: {
			requiresAuth: true,
			product: Permissions.Product.AuditFlowDown,
			name: "AuditFlowDown"
		},

		children: [

			{
				path: "",
				name: "Audit Flow-Down Dashboard",
				alias: "dashboard",
				component: AuditFlowDownDashboard,
				meta: { name: "FlowDownDashboard" }
			},
			{
				path: "flowdownaudits",
				component: EmptyRouterView,
				meta: { name: "Audits" },
				children: [
					{
						path: ":id",
						name: "Audit Flow-Down Details",
						component: FlowDownDetailedView,
						meta: { name: "Audit Flow-Down Details" }
					}
				]
			},
			{
				path: "flowdownauditor",
				component: EmptyRouterView,
				children: [
					{
						path: "",
						name: "Audit Flow-Down Overview",
						component: ClientAuditFlowDownOverview,
						meta: {
							name: "Auditor View",
							resource: Permissions.Resource.AuditRequests,
							operation: "C"
						},
					},
					{
						path: "newflowdown",
						name: "New Flow-Down Request",
						component: RequestAuditFlowDown,
						meta: {
							name: "New Flow-Down Request",
							resource: Permissions.Resource.AuditRequests,
							operation: "C"
						}
					},
					{
						path: "newflowdown/:templateName/:templateID/:FlowDownAuditId",
						name: "New Flow-Down Request",
						component: RequestAuditFlowDown1,
						meta: {
							name: "New Flow-Down Request",
							resource: Permissions.Resource.AuditRequests,
							operation: "C"
						}
					}
				]
			},
			{
				path: "/apikeylist",
				component: ApiKeys,
				meta: {
					requiresAuth: true
				},
				children: [
					{
						path: "",
						name: "API Keys List",
						component: ApiKeysList,
						meta: { name: "API Keys List" }
					}
				]
			},
			{
				path: "flowdownsubmitter",
				component: EmptyRouterView,
				children: [
					{
						path: "",
						name: "Flow-Down Submitter View",
						component: SupplierAuditFlowDownOverview,
						meta: {
							name: "Flow-Down Submitter View",
							resource: Permissions.Resource.Audits
						}
					},
					{
						path: ":id",
						component: EmptyRouterView,
						children: [
							{
								path: "",
								name: "Fill out Flow-Down",
								component: AuditFlowDownInput,
								meta: {
									name: "Fill out Flow-Down",
									resource: Permissions.Resource.Audits,
									operation: "C"
								}
							},
							{
								path: "success",
								name: "Success",
								component: SuccessfulFlowDownSubmissionView,
								meta: {
									name: "Success",
									resource: Permissions.Resource.Audits
								}
							}
						]
					}
				]
			},
			{
				path: "flowdowntemplates",
				component: EmptyRouterView,
				meta: {
					name: "Audit Flow-Down Templates",
					resource: Permissions.Resource.AuditTemplates
				},
				children: [
					{
						path: "",
						name: "Flow-Down Template Overview",
						component: FlowDownTemplateOverview,
						meta: { name: "FlowDownOverview" }
					},
					{
						path: "newflowdown",
						name: "New Flow-Down Audit Template",
						component: NewFlowDownTemplate,
						meta: { name: "NewFlowDown" }
					},
					{
						path: ":id",
						component: EmptyRouterView,
						children: [
							{
								path: "",
								name: "Edit Flow-Down Audit Template",
								component: EditFlowDownTemplate,
								meta: { name: "EditFlowDown" }
							},
							{
								path: "flowdownpreview",
								name: "Preview Audit Template",
								component: FlowDownTemplatePreview,
								meta: { name: "FlowDownPreview" }
							}
						]
					}
				]
			}
		]

	},
	{
		path: "/trace",
		component: TraceView,
		meta: {
			requiresAuth: true,
			product: Permissions.Product.Audit,
			resource: Permissions.Resource.Transactions,
			name: "Trace"
		},
		children: [
			{
				path: "",
				name: "Trace",
				//alias: "",
				component: DashboardView,
				meta: { name: "Dashboard" }
			},
			{
				path: "sender",
				component: EmptyRouterView,
				children: [
					{
						path: "",
						name: "Sender View",
						component: SendTransactionView,
						meta: { name: "Sender View" }
					},
					{
						path: "new",
						name: "Add Transaction",
						component: AddTransaction,
						meta: { name: "Add Transaction" }
					}
				]
			},
			{
				path: "receiver",
				name: "Receiver View",
				component: RecipientView,
				meta: { name: "Receiver View" }
			},
			{
				path: "transactions",
				component: EmptyRouterView,
				meta: { name: "Transactions" },
				children: [
					{
						path: "",
						name: "Sent Transactions",
						component: SendTransactionView,
						meta: { name: "Sent" }
					},
					{
						path: ":id",
						component: EmptyRouterView,
						children: [
							{
								path: "",
								name: "Transaction Details",
								component: TransactionDetailsView,
								meta: { name: "Details" }
							},
							{
								path: "replace",
								name: "Replace Transaction",
								component: ReplaceTransaction,
								meta: { name: "Replace Transaction" }
							},
							{
								path: "forward",
								name: "Forward Transaction",
								component: ForwardTransaction,
								meta: { name: "Forward Transaction" }
							},
							{
								path: "clone",
								name: "Clone Transaction",
								component: CloneTransactionView,
								meta: { name: "Clone Transaction" }
							},
							{
								path: "chain",
								name: "Chain History",
								component: ChainHistoryView,
								meta: { name: "Chain History" }
							},
							{
								path: "comments",
								component: EmptyRouterView,
								meta: { name: "Internal Comments" },
								children: [
									{
										path: "",
										name: "Internal Comments",
										component: TransactionCommentsView,
										meta: { name: "Internal Comments" }
									},
									{
										path: ":comment",
										name: "Comment Details",
										component: CommentView,
										meta: { name: "Comment Details" }
									}
								]
							}
						]
					}
				]
			},
			{
				path: "comments",
				component: EmptyRouterView,
				meta: { name: "Comments" },
				children: [
					{
						path: "",
						name: "Comments List",
						component: CommentsListView,
						meta: { name: "Comments List" }
					}
				]
			},
			{
				path: "drafts",
				component: EmptyRouterView,
				meta: { name: "Drafts" },
				children: [
					{
						path: "",
						name: "Sender View Drafts",
						component: SendTransactionView,
						meta: { name: "Sender View" }
					},
					{
						path: ":id",
						name: "Draft Details",
						component: DraftDetailsView,
						meta: { name: "Draft Details" }
					}
				]
			},
			{
				path: "search",
				name: "Search Transactions",
				component: SearchTransactionView,
				meta: { name: "Search Transactions" }
			}
		]
	},
	{
		path: "/connections",
		component: ConnectionsView,
		meta: {
			requiresAuth: true,
			product: Permissions.Product.Platform
		},
		children: [
			{
				path: "",
				name: "Connections Overview",
				component: ConnectionsOverview,
				meta: { name: "Connections Overview" }
			},
			{
				path: ":id",
				name: "Single Client View",
				component: SingleClientView,
				meta: { name: "Single Client View" }
			}
		]
	},
	{
		path: "/supplier-performance",
		component: SupplierPerformanceView,
		meta: {
			requiresAuth: true,
			product: Permissions.Product.Platform,
		},
		children: [
			{
				path: "",
				redirect: "table",
			},
			{
				path: "table",
				name: "Supplier Performance",
				component: SupplierPerformanceTable,
				meta: {
					name: "Supplier Performance",
				},
			},
			{
				path: "map",
				name: "Supplier Performance Map",
				component: SupplierPerformanceConnectionMap,
				meta: {
					name: "Supplier Performance Map",
				},
			},
		],
	},
	{
		path: "/nis",
		component: NisView,
		name: "NIS",
		meta: {
			requiresAuth: true,
			product: Permissions.Product.Platform,
			resource: Permissions.Resource.NIS,
		},
		children: [
			{
				path: "",
				name: "NIS Survey",
				component: NisSurvey,
				meta: { name: "NIS View" },
			},
			{
				path: "score",
				name: "NIS Score",
				component: NisScore,
				meta: { name: "NIS Score" },
				redirect: { name: "NIS Your Score" },
				children: [
					{
						path: "yours",
						name: "NIS Your Score",
						component: NisYourScore,
						meta: { name: "NIS Score" },
					},
					{
						path: "connections",
						name: "NIS Connections Score",
						component: NisConnectionsScore,
						meta: { name: "NIS Score" },
						redirect: { name: "NIS Connections Table" },
						children: [
							{
								path: "table",
								name: "NIS Connections Table",
								component: NisConnectionsTable,
								meta: { name: "NIS Score" },
							},
							{
								path: "map",
								name: "NIS Connections Map",
								component: NisConnectionsMap,
								meta: { name: "NIS Score" },
							},
						],
					},
				],
			},
			{
				path: "request",
				name: "Request NIS Self-Assessment",
				component: RequestNis,
				meta: { name: "NIS Request" },
			},
			{
				path: "submissions/:id",
				name: "NIS Submission",
				component: NisSurvey,
				meta: { name: "NIS View" },
				props: (route) => ({ assessmentId: route.params.id }),
			},
		],
	},
	{
		path: "/emissions",
		component: EmissionsView,
		meta: {
			requiresAuth: true,
			product: Permissions.Product.Platform,
			resource: Permissions.Resource.CSR
		}
		// children: [
		// 	{
		// 		path: "suppliers",
		// 		name: "Connections Emission Overview",
		// 		component: EmissionsConnectionsList,
		// 		meta: { name: "Connections Emission Overview" }
		// 	},
		// ]
	},
	{
		path: "/emissions/suppliers",
		component: EmissionsConnectionsList,
		meta: { name: "Connections Emission Overview" }
	},
	{
		path: "/emissions/:id",
		component: EmissionsResult,
		meta: {
			requiresAuth: true,
			product: Permissions.Product.Platform,
			resource: Permissions.Resource.CSR
		}
	},
	{
		path: "/risk",
		component: RiskView,
		name: "Risk",
		meta: {
			requiresAuth: true,
			product: Permissions.Product.Platform,
			resource: Permissions.Resource.CSR
		},
		children: [
			{
				path: "dashboard",
				name: "dashboard",
				component: RiskDashboard,
			},
			{
				path: "/RiskDashboardPDF",
				name: "RiskDashboardPDF",
				component: RiskDashboardPDF,
				
			},
			{
				path: "riskpage",
				name: "riskpage",
				component: RiskPage,
			},
			{
				path: "riskdefinition",
				name: "riskdefinition",
				component: RiskDefinition,
			},
			{
				path: "add",
				name: "Add user",
				component: AddRiskViewpoints,
			},
			{
				path: "addaction",
				name: "Add user",
				component: AddActionPlan,
			},
			{
				path: "update",
				name: "Add user",
				component: UpdateRiskViewpoint,
			},
			{
				path: "edit",
				name: "Add user",
				component: EditRiskViewpoint,
			},
			{
				path: "updateaction",
				name: "Add user",
				component: UpdateActionPlan,
			},
			{
				path: "knowledgepage",
				name: "knowledgepage",
				component: KnowledgePage,
				meta: { name: "Sustainability View" }
			},
			{
				path: "isoprocess",
				name: "isoprocess",
				component: ISOprocess,
				meta: { name: "ISO Process View" },
			},
			{
				path: "isoprocess/fullprocessview",
				name: "ISO Processes",
				component: ProcessView,
				meta: { name: "Full Process View" }
			},
		]
	},
	{
		path: "/ProductPlan",
		component: AccountPlan,
		meta: {},
		children: [
			{
				path: "",
				name: "Product Plan",
				component: UpgradePlan,
				meta: { name: "Product Plans" }
			},
			{
				path: "success",
				name: "Payment Success",
				component: PaymentSuccess,
				meta: { name: "Success Payment" }
			},
			{
				path: "fail",
				name: "Payment Fail",
				component: PaymentFail,
				meta: { name: "Fail Payment" }
			},
		]
	},
	{
		path: "/team",
		component: UsersView,
		meta: {
			requiresAuth: true,
			name: "Team"
		},
		children: [
			{
				path: "",
				name: "Users List",
				component: UsersListView,
				meta: { name: "Overview" }
			},
			{
				path: "add",
				name: "Add user",
				component: AddUserView,
				meta: { name: "Add team member" }
			},
			{
				path: "settings",
				name: "Team Settings",
				component: TeamSettings,
				meta: {
					name: "Team Settings",
					requiresAuth: true,
					product: Permissions.Product.Platform,
					resource: Permissions.Resource.Users,
					operation: "U"
				}
			},
			{
				path: ":username",
				name: "Edit user",
				component: EditUserView,
				meta: { name: "Edit team member" }
			},
		]
	},
	{
		path: "/incidentreport",
		name: "Incident Login",
		component: IncidentLogin,
		meta: { guestsOnly: true }
	},
	{
		path: "/incidentreport/form",
		name: "Incident Form",
		component: IncidentForm,
		meta: { guestsOnly: true },
		beforeEnter: (to, from, next) => {
			localStorage.getItem("incidentRole") ? next() : next("/incidentreport")
		}
	},
	{
		path: "/incidentreport/overview",
		name: "Incident Overview",
		component: IncidentOverview,
		meta: { guestsOnly: true },
		beforeEnter: (to, from, next) => {
			localStorage.getItem("incidentRole") === "manager" ? next() : next("/incidentreport")
		}
	},
	{
		path: "/login",
		component: Login,
		name: "Login",
		meta: {
			guestsOnly: true
		}
	},
	{
		path: "/invite",
		component: Invite,
		meta: {
			guestsOnly: true
		}
	},
	{
		path: "/register",
		component: Register,
		meta: {
			guestsOnly: true
		}
	},
	{
		path: "/join",
		component: JoinView,
		meta: {
			guestsOnly: true
		}
	},
	{
		path: "/reset",
		component: Reset,
		meta: {
			guestsOnly: true
		}
	},
	{
		path: "/resetpassword",
		name: "Password Reset",
		component: EPR,
		meta: {
			name: "Password Reset",
			requiresAuth: true
		}
	},
	{
		path: "/forgot",
		component: Forgot,
		meta: {
			guestsOnly: true
		}
	},
	{
		path: "/verify",
		component: Verify,
		meta: {
			name: "Verify Email"
		}
	},
	{
		path: "/logout",
		beforeEnter() {
			store.dispatch("user/logoutRequest")
			window.location = "/login"
		},
		meta: {
			requiresAuth: false
		}
	},
	{
		path: "/verifyemail",
		component: VerifyEmailView
	}
]

const router = new VueRouter({
	mode: "history",
	routes,
	base: process.env.BASE_URL || "/"
})

router.beforeEach((to, _, next) => {
	try {
		//console.log(`Route to name: ${to.name}`)
		if (
			store.getters["user/forcePasswordReset"] == true &&
			to.name != "Password Reset"
		) {
			return next({ name: "Password Reset" })
		} else if (
			store.getters["user/forcePasswordReset"] == false &&
			to.name == "Password Reset"
		) {
			return next({ name: "Portal" })
		}
		if (to.name == "Audit Dashboard" && accessToRoute({ name: "Audit Overview" })) {
			return next({ name: "Audit Overview" })
		} else if (to.name == "Audit Dashboard") {
			return next({ name: "Submitter View" })
		}
		if (to.name == "Audit Flow-Down Dashboard" && accessToRoute({ name: "Audit Flow-Down Overview" })) {
			return next({ name: "Audit Flow-Down Overview" })
		} else if (to.name == "Audit Flow-Down Dashboard") {
			return next({ name: "Flow-Down Submitter View" })
		}
		if (to.name == "Audit Onsite Dashboard" && accessToRoute({name: "Onsite Initiator Dashboard"})) {
			return next({name: "Onsite Initiator Dashboard"})

		} else if (to.name == "Audit Onsite Dashboard") {
			return next({name: "Onsite Supplier View"})
		}
		if (store.getters["user/isLoggedIn"] && store.getters["user/isGuest"] && to.path !== "/guestPortal") {
			return next({ path: "/guestPortal" })
		}
		if (to.matched.some(record => record.meta.requiresAuth)) {
			if (store.getters["user/isLoggedIn"]) {
				if (accessToRoute(to.path)) {
					// User has access
					if (to.name === "Audit Onsite Dashboard") {
						return next({ name: "Audit Onsite Overview" })
					}
					return next()
				} else {
					// User does NOT have access
					if (to.name === "Audit Onsite Dashboard" || to.path.startsWith("/auditonsite")) {
						store.dispatch(
							"loading/" + LoadingState.ACTION_SET_ERROR,
							"You have not the required role for Onsite Audit. Please add Onsite Auditor role.",
							{ root: true }
						)
						return next({ path: "/" })
					}

					if (to.name === "NIS" || to.path.startsWith("/nis")) {
						store.dispatch(
							"loading/" + LoadingState.ACTION_SET_ERROR,
							"You don't have access to NIS. Please add the NIS Coordinator or NIS Auditor role.",
							{ root: true }
						)
						return next({ path: "/" })
					}

					if (to.name != "Portal") {
						store.dispatch(
							"loading/" + LoadingState.ACTION_SET_ERROR,
							"You are not authorized to access this page.",
							{ root: true }
						)
						return next({ path: "/" })
					} else {
						store.dispatch("user/logoutRequest", { root: true })
						return next({ name: "Login" })
					}
				}
			} else {
				if (to.name != "Login") {
					store.dispatch("loading/RESET_ERROR", { root: true })
					return next({ name: "Login", query: { redirect: to.fullPath } })
				} else {
					return next(false)
				}
			}


			/* Check if link is guest-only (login page, etc) */
		} else if (to.matched.some(record => record.meta.guestOnly)) {
			if (
				store.getters["user/isLoggedIn"] &&
				store.getters["user/isGuest"]
			) {
				return next()
			}
			return next({
				name: "Portal"
			})
		} else {
			return next()
		}
	} catch (e) {
		console.error(e)
		return next(to)
	}
})

export default router
